export default __webpack_public_path__ + "static/media/blogpic2.9df1c100.png";